import { render, staticRenderFns } from "./OmxCard.vue?vue&type=template&id=7eb069e4&scoped=true"
import script from "./OmxCard.vue?vue&type=script&lang=js"
export * from "./OmxCard.vue?vue&type=script&lang=js"
import style0 from "./OmxCard.vue?vue&type=style&index=0&id=7eb069e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb069e4",
  null
  
)

export default component.exports